import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FeatureCollection, Point } from 'geojson';
import { environment } from 'src/environments/environment';
import { GridWithQuantiles } from '../models/altitude';

@Injectable({
  providedIn: 'root'
})
export class CommunityService {
  
  constructor(private http: HttpClient) { }

  getAll() {
    console.log(`${environment.serverBaseUrl}/comunidade`)
    return this.http.get<FeatureCollection>(`${environment.serverBaseUrl}/comunidade`);
  }

  getConservationUnit() {
    console.log(`${environment.serverBaseUrl}/conservation`)
    return this.http.get<FeatureCollection>(`${environment.serverBaseUrl}/conservation`);
  }

  getAltitude() {
    console.log(`${environment.serverBaseUrl}/altitude`)
    return this.http.get<GridWithQuantiles>(`${environment.serverBaseUrl}/altitude`);
  }

  getCluster2() {
    console.log(`${environment.serverBaseUrl}/cluster2`)
    return this.http.get<FeatureCollection>(`${environment.serverBaseUrl}/cluster2`);
  }

  getCluster5() {
    console.log(`${environment.serverBaseUrl}/cluster5`)
    return this.http.get<FeatureCollection>(`${environment.serverBaseUrl}/cluster5`);
  }

  getCluster6() {
    console.log(`${environment.serverBaseUrl}/cluster6`)
    return this.http.get<FeatureCollection>(`${environment.serverBaseUrl}/cluster6`);
  }

  getCluster7() {
    console.log(`${environment.serverBaseUrl}/cluster7`)
    return this.http.get<FeatureCollection>(`${environment.serverBaseUrl}/cluster7`);
  }

  getIncident() {
    console.log(`${environment.serverBaseUrl}/incident`)
    return this.http.get<GridWithQuantiles>(`${environment.serverBaseUrl}/incident`);
  }
}
